import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import ProductOccupancyGraph from './ProductOccupancyGraph';
import NoResults from 'components/form/styling/NoResults';
import translate from 'components/hoc/translate';
import { generateDatasetObject } from 'helpers/graph';
import utils from 'helpers/utils';
import { fetchProductOccupancy } from 'store/actions/products/occupancy/fetchProductOccupancy';

class ProductOccupancyGraphContainer extends Component {
    state = {
        datasets: null,
    };

    componentDidUpdate(prevProps) {
        const { datasets } = this.state;
        const {
            query,
            rawData,
        } = this.props;

        const isDifferent = !utils.isEmpty(utils.diffObjects(prevProps.query, query));

        if (isDifferent) {
            return this.fetchProductOccupancy(query);
        }

        if (!utils.isEmpty(utils.diffArrays(rawData, prevProps.rawData))) {
            return this.generateDatasets();
        }

        if (!datasets && !utils.isEmpty(rawData)) {
            return this.generateDatasets();
        }
    }

    generateDatasets = () => {
        const {
            query: {
                interval,
            },
            rawData,
            translate,
        } = this.props;

        const datasets = [];

        if (!utils.isEmpty(rawData)) {
            Object.keys(rawData[0].values).map((key, index) => {
                const values = utils.map(rawData, (data) => {
                    return data.values[key];
                });

                datasets[index] = generateDatasetObject(values, index, key,
                    translate(`resources.products.occupancy.graph.label.${ interval }.${ key }`),
                );
            });
        }

        return this.setState({
            datasets: datasets,
        });
    }

    fetchProductOccupancy = (query) => {
        const {
            fetchOccupancy,
        } = this.props;

        query = {
            ...query,
            from: `${ query.from } 00:00:00`,
            to: `${ query.to } 23:59:59`,
        };

        const payload = utils.filterEmptyValues(query);

        return fetchOccupancy(payload);
    }

    render() {
        const {
            loading,
            query: {
                interval,
            },
            rawData,
            translate,
        } = this.props;

        const { datasets } = this.state;

        if (utils.isEmpty(datasets)) {
            return <NoResults label='resources.products.occupancy.graph.no_results' />;
        }

        return (
            <ProductOccupancyGraph
                datasets={ datasets }
                interval={ interval }
                loading={ loading }
                rawData={ rawData }
                title={ translate('resources.products.occupancy.graph.title') }
            />
        );
    }
}

ProductOccupancyGraphContainer.propTypes = {
    fetchOccupancy: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    query: PropTypes.shape({
        from: PropTypes.string,
        interval: PropTypes.string,
        to: PropTypes.string,
    }).isRequired,
    rawData: PropTypes.arrayOf(PropTypes.object).isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        productOccupancy: {
            data,
            loading,
        },
    } = state;

    const {
        form,
        product,
    } = props;

    const formSelector = formValueSelector(form);
    const query = formSelector(state, 'from', 'interval', 'to');
    const hasCapacity = product.configuration && product.configuration.capacity;

    const rawData = utils.map(data, (object) => {
        if (hasCapacity) {
            object.values.capacity = product.configuration.capacity;
        }

        return object;
    });

    return {
        loading: loading,
        query: query,
        rawData: utils.reverse(rawData),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        fetchOccupancy: (payload) => {
            dispatch(fetchProductOccupancy(payload, props.id));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate
);

export default enhance(ProductOccupancyGraphContainer);


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/graph/ProductOccupancyGraphContainer.js